
import { useParams, useNavigate } from "react-router-dom";
import { Shell } from "@/components/layout/Shell";
import { ContractTypeForm } from "@/components/contract-types/ContractTypeForm";
import { useContractTypes } from "@/hooks/useContractTypes";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { ContractDirection } from "@/lib/types";

export default function ContractTypeEditPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { useContractTypeQuery } = useContractTypes();
  const { data: contractType, isLoading, error } = useContractTypeQuery(id || "");
  
  console.log("Contract type data in edit page:", contractType);
  
  if (isLoading) {
    return (
      <Shell>
        <div className="flex items-center justify-center py-12">
          <p className="text-muted-foreground">Loading contract type...</p>
        </div>
      </Shell>
    );
  }
  
  if (error || !contractType) {
    return (
      <Shell>
        <div className="space-y-6">
          <h1 className="text-3xl font-bold tracking-tight">Contract Type Not Found</h1>
          
          <Alert variant="destructive">
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>Error</AlertTitle>
            <AlertDescription>
              {error ? `Error loading contract type: ${(error as Error).message}` : "The requested contract type could not be found."}
            </AlertDescription>
          </Alert>
          
          <Button onClick={() => navigate("/contract-types")}>
            Return to Contract Types
          </Button>
        </div>
      </Shell>
    );
  }

  return (
    <Shell>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Edit Contract Type</h1>
          <p className="text-muted-foreground mt-2">
            Update the contract type details
          </p>
        </div>

        <ContractTypeForm 
          mode="edit" 
          contractType={{
            id: contractType.id,
            name: contractType.name,
            description: contractType.description,
            auto_renews: contractType.auto_renews,
            renewal_interval: contractType.renewal_interval,
            renewal_unit: contractType.renewal_unit,
            direction: contractType.direction as ContractDirection
          }} 
        />
      </div>
    </Shell>
  );
}
